/**
 * created by wang lei
 删除表格 页面
 *
 */
import React, {Component} from 'react';
import deleteTable from './deleteTable.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class DeleteTableTool extends Component {
   constructor(props) {
        super(props);
        this.state = {
            isShowDeleteTable:false
        }
    }


    /**
     * 监听内容变化
     */
    listenContentChange(){
       let isShowDeleteTable = this.props.editor.queryCommandState('deleteTable')
        this.setState({isShowDeleteTable: isShowDeleteTable === 0});
    }

    /**
     * 监听编辑器点
     */
    listenContentClick(){
        let isShowDeleteTable = this.props.editor.queryCommandState('deleteTable')
        this.setState({isShowDeleteTable: isShowDeleteTable === 0});
    }
    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.isShowDeleteTable ? "1":"0.3"}}>
                <img className={"editor-delete-table-tool-btn"} src={deleteTable}
                     onClick={()=>this.props.editor.execCommand("deletetable")}
                />
                {this.state.isShowDeleteTable ? <style>{`
                .editor-delete-table-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-delete-table-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-delete-table-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-delete-table-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-delete-table-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-delete-table-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}